export default "__VITE_ASSET__5da5ffe9__"